angular.module('app.directives').directive('vpSavePanel', ($rootScope, $timeout) => ({
    restrict: 'A',

    scope: {
        model: '=',
    },

    link(scope, element, attrs) {
        scope.isDirty = false;
        scope.original = '';

        $rootScope.$on('edit-panel-ready', () => {
            $timeout(() => {
                scope.original = angular.toJson(scope.model);
                scope.isDirty = false;
                angular.element(element).removeClass('md-accent');
            }, 250);
        });

        scope.$watch(
            () => angular.toJson(scope.model),
            (newValue) => {
                scope.isDirty = newValue !== scope.original;

                if (scope.isDirty) {
                    angular.element(element).addClass('md-accent');
                } else {
                    angular.element(element).removeClass('md-accent');
                }
            }
        );
    },
}));
